import { ReactElement, ReactNode } from "react";
interface TableWrapperProps {
  children: ReactNode;
}
export default function Table(props: TableWrapperProps): ReactElement {
  return <table className="table w-full fsu-table">{props.children}</table>;
}
